import * as React from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';
import { getColor } from '@/lib/get-color';
import { TicketChannelOption } from '@/constants/ticket-channel-option.enum';
import {
  ticketLastActivitySelector,
  ticketChannelSelector,
  ticketUserSelector,
} from '@/redux/app/selectors/ticket';

interface TicketCardProps {
  ticket: string
}

const dateFormat = {
  day: 'numeric' as const,
  month: 'long' as const,
  year: 'numeric' as const,
  hour12: true as const,
  hour: 'numeric' as const,
  minute: 'numeric' as const,
};

export const TicketCardRight = ({ ticket }: TicketCardProps) => {
  const channel = useSelector(_.partial(ticketChannelSelector, ticket)) || {};
  const user = useSelector(_.partial(ticketUserSelector, ticket));
  const lastActivity = useSelector(_.partial(ticketLastActivitySelector, ticket));
  const sentAt = lastActivity && new Date(lastActivity.sent_at * 1000);

  let channelLabel: string;

  switch (channel) {
    case TicketChannelOption.LIVE_CHAT:
      channelLabel = 'LIVE CHAT';
      break;
    case TicketChannelOption.WHATSAPP:
      channelLabel = 'WhatsApp';
      break;
    default: // TicketChannelOption.SMS
      channelLabel = 'SMS';
  }

  return (
    <div className="ticket-right">
      <span
        className="display-channel"
        data-origin={channel}
      >
        {channelLabel}
      </span>
      <div>
        <h5 className="display-assignee" data-turbolinks="false">
          {(user
            ? (
              /* <%= link_to(ticket.user.try(:name), account_ticket_path(ticket.account, ticket.uuid, {
                user_id: ticket.user.hash_id,
                search: params[:search] || '',
                status: params[:status] || '',
                archived: params[:archived] || '',
                unaddressed: params[:unaddressed] || '',
                order: params[:order] || '',
              }), {
                style: "color:##{get_color(ticket.user)};",
                class: 'assigned-name',
              }) %> */
              <a className="assigned-name" style={{ color: getColor(user.name) }}>
                {user.name}
              </a>
            )
            : <span className="unassigned-text">Unassigned</span>
          )}
        </h5>
        <h5 className="display-assignee-initials" data-turbolinks="false">
          {(user
            ? (
              /* <%= link_to(ticket.user.try(:initials), account_ticket_path(ticket.account, ticket.uuid, {
                user_id: ticket.user.hash_id,
                search: params[:search] || '',
                status: params[:status] || '',
                archived: params[:archived] || '',
                unaddressed: params[:unaddressed] || '',
                order: params[:order] || '',
              }), {
                style: "color:##{get_color(ticket.user)};",
                class: 'assigned-name',
              }) %> */
              <a className="assigned-name" style={{ color: getColor(user.name) }}>
                {user.initials}
              </a>
            )
            : <span className="unassigned-text">N/A</span>
          )}
        </h5>
        <span className="time-ago">
          {!sentAt ? null : (
            <time dateTime={sentAt.toISOString()} data-local="time-ago">
              {sentAt.toLocaleString('en-US', dateFormat)}
            </time>
          )}
        </span>
      </div>
    </div>
  );
};
